//Mapping of Emojies for Character Gender and Species
export const genderEmojis = {
    Female:"♀️",
    Male:"♂️",
    Genderless:"👨",
    unknown:"❌"
}

export const speciesEmojis = {
    Human:"👨",
    Alien:"👽",
    Humanoid:"🗿",
    Disease:"🦠",
    Robot:"🤖",
    Animal:"🦊",
    "Mythological Creature":"✴️"
}
